import type { ReferentialInterventionType } from "./referential-intervention-types.type";
import type { Int } from "@/types";

export const getInterventionTypeAndSubType = (
  intervention: { intervention_type_id?: Int; intervention_sub_type_id?: Int },
  interventionTypes: ReferentialInterventionType[]
) => {
  const interventionType = interventionTypes.find(
    (interventionType) =>
      interventionType.id === intervention.intervention_type_id
  );

  const interventionSubType = interventionType?.subtypes?.find(
    (interventionSubType) =>
      interventionSubType.id === intervention.intervention_sub_type_id
  );

  return { interventionType, interventionSubType };
};
